/** Frontmatter for the "week4-waiver-wire-darkness-report" article; the Body lives in week4-waiver-wire-darkness-report.jsx. */
const meta = {
  slug: 'week4-waiver-wire-darkness-report',
  title: 'Week 4 Waiver Wire: The Darkness Report',
  category: 'Waivers',
  author: 'Andy Darkness',
  excerpt:
    'Braelon Allen, Ollie Gordon II and Kenyon Sadiq lead a Week 4 wire reshaped by Achane, Hall and Mayfield. A FAAB ladder, the full board, a D/ST streaming chart built on implied totals, an IDP board, the injury ledger and the bid sheet.',
  readMinutes: 15,
  date: '2026-09-29',
};

export default meta;
